import { getCookie } from '@/features/shared/utils/cookies'
import { isOnServer } from '@shared/constants/util'
import { INFERRED_ZIP } from '@shared/constants/zip'
import { queryOptions } from '@tanstack/react-query'

export const inferredZipQueryOptions = queryOptions({
  queryKey: ['inferredZip'],
  queryFn: (): string | null => {
    if (isOnServer()) {
      throw new Error('inferredZipQueryOptions queryFn should not be called on the server')
    }
    return getCookie(INFERRED_ZIP) ?? null
  },
  gcTime: Infinity,
  staleTime: Infinity,
})
